import { render, staticRenderFns } from "./EditPrewrittenNotesModal.vue?vue&type=template&id=1d3d33b8&"
import script from "./EditPrewrittenNotesModal.vue?vue&type=script&lang=js&"
export * from "./EditPrewrittenNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPrewrittenNotesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports